import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-client-form',
  templateUrl: './client-form.component.html',
  styleUrls: ['./client-form.component.css']
})
export class ClientFormComponent {
  form: FormGroup;
  submitted = false; // Declare the submitted property here
  // @Input() public firstName; 

  @Input() formData: any = {};
  @Output() formDataChange = new EventEmitter<any>();
  @Output() submitForm = new EventEmitter<any>();

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.group({
      personalId: [''], // ת.ז. / ח.פ (Not required)
      lastName: [''], // שם משפחה/חברה (Not required)
      firstName: ['', Validators.required], // שם פרטי (Required)
      mobilePhone: ['', [Validators.required, Validators.pattern('^\\+?[0-9]{9,13}$')]], // טלפון נייד (Required)
      // mobilePhone: ['', [Validators.required, Validators.pattern('^\\+?[1-9][0-9]{7,14}$')]], // טלפון נייד (Required)
      city: [''], // עיר (Not required)
      street: [''], // רחוב (Not required)
      buildingNumber: [''], // מס' בניין (Not required)
      email: ['', [Validators.required, Validators.email]] // מייל (Required)
    });

    this.form.valueChanges.subscribe(value => {
      this.formDataChange.emit(value);
    });
 
   this.form.get('firstName')?.setValue(this.formData.firstName);
   this.form.get('lastName')?.setValue(this.formData.lastName);
   this.form.get('mobilePhone')?.setValue(this.formData.mobilePhone);
   this.form.get('email')?.setValue(this.formData.email);
  }

  // Helper function to access the form controls from the template
  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true; // Set to true when the form is attempted to be submitted

    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);
        control.markAsTouched({ onlySelf: true });
      });
      return; // Stop here if the form is invalid
    }

    console.log(this.form.value);
    // Handle your form submission (e.g., send data to an API)
  }
}